import { useQueryClient } from "@tanstack/vue-query";

import { amplifyAuthQueryKeys } from "~/queries/amplify/auth";

/**
 * Registers a watcher for auth state changes in other tabs. It is meant to be used only once for the app
 */
export const useAuthBroadcastListener = () => {
  const { amplifyAuthState } = useAmplifyAuthBroadcastChannel();
  const queryClient = useQueryClient();

  watch(
    amplifyAuthState,
    (newAuthState) => {
      if (!newAuthState) return;

      queryClient.setQueryData(
        amplifyAuthQueryKeys.isAuthenticated().queryKey,
        newAuthState.isLoggedIn,
      );

      if (newAuthState.isLoggedIn === false)
        postLogoutQueryInvalidation(queryClient);
    },
    { deep: true },
  );
};
